(function () {
  function initGallery(gallery) {
    if (gallery.dataset.tapInit === 'true') return;
    gallery.dataset.tapInit = 'true';

    var images = gallery.querySelectorAll('.blog-tap-card__image');
    if (images.length <= 1) return;

    // Preload every image immediately so swaps are instant
    images.forEach(function (img) {
      if (img.loading === 'lazy') img.loading = 'eager';
      // Force the browser to actually fetch by touching the current src
      if (!img.complete) {
        var preload = new Image();
        if (img.srcset) preload.srcset = img.srcset;
        preload.src = img.src;
      }
    });

    var trigger = gallery.querySelector('[data-tap-trigger]');
    var current = 0;

    function showIndex(i) {
      images[current].classList.remove('is-active');
      current = (i + images.length) % images.length;
      images[current].classList.add('is-active');
    }

    function next(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      showIndex(current + 1);
    }

    function prev(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      showIndex(current - 1);
    }

    if (!trigger) return;

    // Swipe detection
    var SWIPE_THRESHOLD = 40; // px — must move at least this far to count as a swipe
    var startX = 0;
    var startY = 0;
    var pointerDown = false;
    var didSwipe = false;

    trigger.addEventListener('pointerdown', function (e) {
      pointerDown = true;
      didSwipe = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    trigger.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      // If horizontal movement is significant and exceeds vertical, it's a swipe
      if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        didSwipe = true;
        if (dx < 0) {
          next(e); // swipe left → next
        } else {
          prev(e); // swipe right → previous
        }
        pointerDown = false;
      }
    });

    trigger.addEventListener('pointerup', function () { pointerDown = false; });
    trigger.addEventListener('pointercancel', function () { pointerDown = false; });

    trigger.addEventListener('click', function (e) {
      // If it was a swipe, don't also fire a tap
      if (didSwipe) { e.preventDefault(); e.stopPropagation(); return; }
      next(e);
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowRight') {
        next(e);
      } else if (e.key === 'ArrowLeft') {
        prev(e);
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-tap-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();